/* Maison RM : choix des variantes, ajout au panier et bouton collé de la fiche produit */
(function () {
  function money(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',').replace(',00', '');
    return v + ' €';
  }

  function init(root) {
    var data = JSON.parse(root.querySelector('[data-product-json]').textContent);
    var form = root.querySelector('form.mrm-form');
    var idInput = root.querySelector('[data-variant-input]');
    var labels = root.querySelectorAll('[data-atc-label]');
    var buttons = [root.querySelector('[data-atc]'), root.querySelector('[data-sticky-btn]')];
    var priceEl = root.querySelector('[data-price]');
    var errorEl = root.querySelector('[data-error]');
    var sticky = root.querySelector('[data-sticky]');

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('.mrm-opt'), function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function findVariant(values) {
      return data.variants.find(function (v) {
        return values.every(function (val, i) { return v.options[i] === val; });
      });
    }

    function update() {
      var values = selected();
      root.querySelectorAll('.mrm-opt').forEach(function (fs, i) {
        var l = fs.querySelector('[data-option-label]');
        if (l) l.textContent = values[i] || '';
      });
      var v = findVariant(values);
      var text;
      if (!v) {
        text = 'Indisponible';
      } else {
        idInput.value = v.id;
        text = v.available ? 'Ajouter au panier · ' + money(v.price) : 'Épuisé';
        var p = money(v.price);
        if (v.compare_at_price && v.compare_at_price > v.price) p += '<s>' + money(v.compare_at_price) + '</s>';
        priceEl.innerHTML = p;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
        if (v.featured_media) {
          var item = root.querySelector('[data-media-id="' + v.featured_media.id + '"]');
          var gal = root.querySelector('.mrm-gal');
          if (item && gal && window.matchMedia('(max-width: 989px)').matches) {
            gal.scrollTo({ left: item.offsetLeft - gal.offsetLeft, behavior: 'smooth' });
          }
        }
      }
      labels.forEach(function (l) { l.textContent = text; });
      buttons.forEach(function (b) { if (b) b.disabled = !(v && v.available); });
      errorEl.hidden = true;
    }

    root.querySelectorAll('.mrm-opt input').forEach(function (inp) {
      inp.addEventListener('change', update);
    });

    function openCart(state) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && state && state.sections) {
        try {
          drawer.classList.remove('is-empty');
          drawer.renderContents(state);
          return;
        } catch (e) { /* on bascule sur la page panier */ }
      }
      window.location.href = '/cart';
    }

    function add(e) {
      if (e) e.preventDefault();
      var btn = buttons[0];
      if (!btn || btn.disabled) return;
      buttons.forEach(function (b) { if (b) b.setAttribute('aria-busy', 'true'); });
      var fd = new FormData(form);
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
        fd.append('sections_url', window.location.pathname);
        if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);
      }
      fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          if (state.status) {
            errorEl.textContent = state.description || state.message || "Impossible d'ajouter cette pièce.";
            errorEl.hidden = false;
            return;
          }
          openCart(state);
        })
        .catch(function () {
          errorEl.textContent = "La connexion a échoué. Réessayez dans un instant.";
          errorEl.hidden = false;
        })
        .finally(function () {
          buttons.forEach(function (b) { if (b) b.removeAttribute('aria-busy'); });
        });
    }

    form.addEventListener('submit', add);
    var sb = root.querySelector('[data-sticky-btn]');
    if (sb) sb.addEventListener('click', add);

    var main = buttons[0];
    if (sticky && main && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var off = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', off);
        sticky.setAttribute('aria-hidden', off ? 'false' : 'true');
        if (sb) sb.tabIndex = off ? 0 : -1;
      }).observe(main);
    }
  }

  document.querySelectorAll('.mrm-pdp').forEach(init);
})();
